import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.625 8.426 5.5 12.576a.86.86 0 0 1-.625.275.86.86 0 0 1-.625-.275.875.875 0 0 1 0-1.275l4.125-4.125h-3.25a.87.87 0 0 1-.64-.257.86.86 0 0 1-.26-.638.88.88 0 0 1 .26-.642.86.86 0 0 1 .64-.263h5.4a.87.87 0 0 1 .641.26.87.87 0 0 1 .26.64v5.4a.88.88 0 0 1-.258.641.86.86 0 0 1-.638.26.88.88 0 0 1-.642-.26.86.86 0 0 1-.263-.64v-3.25M9.3 1.801a.87.87 0 0 1-.64-.257.86.86 0 0 1-.26-.638.88.88 0 0 1 .26-.642.87.87 0 0 1 .64-.263H15q.743 0 1.271.53.53.527.53 1.27v5.7a.88.88 0 0 1-.258.641.86.86 0 0 1-.638.26.88.88 0 0 1-.642-.26.86.86 0 0 1-.263-.64v-5.7zm-7.5 15a1.73 1.73 0 0 1-1.27-.529 1.73 1.73 0 0 1-.53-1.27V.902Q0 .517.257.258A.86.86 0 0 1 .895 0a.88.88 0 0 1 .643.26A.86.86 0 0 1 1.8.9V15h14.1q.384 0 .641.257a.86.86 0 0 1 .26.638.88.88 0 0 1-.26.643.87.87 0 0 1-.64.262z"
    }, null, -1)
  ]))]))
}
export default { render: render }